import React from 'react';
import {Link} from "react-router";
import {FaMicrophone} from "react-icons/fa6";
import digital from "../assets/343digital.png";

function Podcasts(props) {
    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
          <span className="breadcumb__title">
            PODCASTLER
          </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            {" "}
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>{" "}
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">PODCASTLER</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="about-us py-120">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-md-7 pe-lg-5">
                            <div className="about-left">
                                <div className="about-left__thumbs">
                                    <img src="assets/images/thumb/about-img-01.png" alt=""/>
                                    <img src={digital} alt=""/>
                                </div>
                                <div className="about-24">
                                    <span className="about-24__text"><FaMicrophone style={{
                                        position: "relative",
                                        bottom: "20px",
                                    }}/></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="about-content">
                                <div className="section-heading style-two">

                                    <Link to={"/podcast/343-digital"} reloadDocument>
                                        <h2 className="section-heading__title">
                                            <span className="section-heading__title-colored"> 343 DIGITAL</span>{" "}
                                        </h2>
                                    </Link>
                                    <p className="section-heading__desc">

                                        343 Digital, sporun dijital dünyasında yalansız dolansız, bot hesapsız ve bağımsız bir içerik platformu olarak öne çıkıyor.

                                        Adımızı, futbolun en ofansif formasyonlarından biri olan 3-4-3'ten alıyoruz ve bu anlayışla sahada olduğu gibi içeriklerimizde de doğrudan, hızlı ve etkili olmayı hedefliyoruz. Amacımız, izleyicilerimize zengin, sürükleyici ve dikkat çekici içerikler sunmak.

                                        Futbolu sadece sahada değil, hayatın her anında yaşayan bir topluluğa hitap ediyoruz. İbrahim Seten önderliğinde, spor dünyasında ezberleri bozarak yeni, heyecan verici içeriklerle spor tutkunlarının karşısına çıkmaya devam ediyoruz.
                                        <br/>
                                        <Link to="/podcast/343-digital" style={{float:"right", color:"red", fontWeight:"bold"}} reloadDocument>Tüm Podcastler</Link>
                                    </p>

                                </div>
                                {/*<div className="about-info">*/}
                                {/*    <div className="about-info__thumb">*/}
                                {/*        <img src="assets/images/thumb/about-img.png" alt="" />*/}
                                {/*    </div>*/}
                                {/*    <div className="about-info__details">*/}
                                {/*        <h5 className="about-info__name">Transport Signal</h5>*/}
                                {/*        <span className="about-info__designation">CEo,Fmlab</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Podcasts;